/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_Role_LabelInputs */

const en_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Role`)
};

const fr_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rôle utilisateur`)
};

const de_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerrolle`)
};

const it_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruolo utente`)
};

const ru_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роль пользователя`)
};

const es_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol de usuario`)
};

const zh_cn2_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户角色`)
};

const ja_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーロール`)
};

const hi_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता भूमिका`)
};

const pt_pt2_team_manager_user_role_label = /** @type {(inputs: Team_Manager_User_Role_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Função do usuário`)
};

/**
* | output |
* | --- |
* | "User Role" |
*
* @param {Team_Manager_User_Role_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_role_label = /** @type {((inputs?: Team_Manager_User_Role_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Role_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_user_role_label(inputs)
	if (locale === "de") return de_team_manager_user_role_label(inputs)
	if (locale === "it") return it_team_manager_user_role_label(inputs)
	if (locale === "ru") return ru_team_manager_user_role_label(inputs)
	if (locale === "es") return es_team_manager_user_role_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_user_role_label(inputs)
	if (locale === "ja") return ja_team_manager_user_role_label(inputs)
	if (locale === "hi") return hi_team_manager_user_role_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_user_role_label(inputs)
	return en_team_manager_user_role_label(inputs)
});